import React from 'react';
import { getTexts } from '../config/texts';
import './Footer.css';

const Footer = ({ language }) => {
  const texts = getTexts('footer', language);

  return (
    <footer>
      <p>{texts}</p>
    </footer>
  );
};

export default Footer;